import { AccessLevel } from "@/api/williams/users";
import { ConfirmationDialog, InformationDialog } from "@/components/dialogs";
import { TagsInput } from "react-tag-input-component";
import { TestEvent } from "@/api/williams/testEvents";
import { TestSelectionDialog } from "../../standardTests/dialogs";
import { useFormContext } from "react-hook-form";
import { useModalDialog } from "@/hooks";
import { usePermissions } from "../../users/hooks";

import styles from "./TestInput.tsx.module.css";

export function TestInput({ data }: Readonly<{ data: TestEvent }>) {
  const form = useFormContext<TestEvent>();
  const dialog = useModalDialog();
  const permissions = usePermissions();

  function handleSelectTests() {
    dialog.show(TestSelectionDialog, {
      testEvent: data,
      initialTests: data.tests,
      contractorId: data.contractorId,
      onAccept: (selectedTests) => {
        form.setValue("tests", selectedTests, { shouldDirty: true });
        form.clearErrors("tests");
      },
    });
  }

  function handleTestRemoved(number: string) {
    const test = data.tests.find((x) => x.templateNumber === number);

    if (test) {
      if (data.welderTests.some((x) => x.templateId === test.recordId && x.submitted)) {
        dialog.show(InformationDialog, {
          caption: "Remove Test",
          message: "You cannot remove a test once results have been submmitted",
        });
      } else {
        dialog.show(ConfirmationDialog, {
          caption: "Remove Test",
          message: `Are you sure you want to remove ${number}?`,
          onAccept: () => {
            const tests = data.tests.filter((x) => x.recordId !== test.recordId);
            form.setValue("tests", tests, { shouldDirty: true });
          },
        });
      }
    }
  }

  return (
    <div className={styles.tagsInput}>
      <TagsInput
        value={data.tests.map((test) => test.templateNumber)}
        onRemoved={handleTestRemoved}
        disabled={data.locked || permissions.data?.accessLevel === AccessLevel.GeneralUser}
      />
      {permissions.data?.accessLevel !== AccessLevel.GeneralUser && (
        <button
          className="btn btn-default mt-2"
          onClick={handleSelectTests}
          disabled={!data.contractorId || data.locked}
        >
          Select Tests
        </button>
      )}
    </div>
  );
}
